<template>
  <cube-button
    open-type="launchApp"
    app-parameter="xxx"
    tip="需在微信小程序环境预览"
    bind:launchApp="onLaunchApp"
  >打开 APP</cube-button>
</template>

<script>
import { createComponent } from '@mpxjs/core'

createComponent({
  methods: {
    onLaunchApp(e) {
      console.log('onLaunchApp...', e && e.detail, e)
    }
  }
})
</script>

<script type="application/json">
  {
    "usingComponents": {
      "cube-button": "@mpxjs/mpx-cube-ui/src/components/button/index"
    }
  }
</script>
